const objective = (subtopicId, sourceSubtopicId, name, tier = "core") => ({
  subtopicId,
  sourceSubtopicId,
  name,
  tier,
});

export default {
  schemaVersion: 1,
  id: "cambridge-igcse-chemistry-states-of-matter-v1",
  subject: "Chemistry",
  chapter: "States of matter",
  title: "States of Matter",
  subtitle: "Move from observable properties to the particle model, then use that model to explain change, gases and diffusion.",
  topics: [
    {
      key: "solids-liquids-gases",
      title: "Solids, liquids and gases",
      topicRef: { topicId: 1, sourceTopicId: 163, name: "Solids, liquids and gases" },
      sections: [
        {
          key: "states-properties",
          title: "Solids, Liquids & Gases",
          intro: "Begin with what students can observe: shape, volume, flow and compressibility. The particle model comes next as the explanation for those properties.",
          keyIdeas: ["Solids, liquids and gases have different macroscopic properties.", "Those properties provide evidence for different particle arrangements."],
          objectives: [objective(1, 1, "Core - Properties of Solids, Liquids and Gases")],
          primaryVideoNames: ["States of matter-I"],
        },
        {
          key: "particle-model",
          title: "The Particle Model",
          intro: "Zoom in from what matter does to how particles are arranged and how they move. Use the model to explain, not merely label, the three states.",
          keyIdeas: ["Particles are arranged, spaced and moving differently in solids, liquids and gases.", "Particle motion helps explain observable properties."],
          objectives: [objective(2, 2, "Core - Particle Arrangement and Motion in States of Matter")],
          primaryVideoNames: ["Characteristics of particles of matter"],
        },
        {
          key: "changing-state",
          title: "Changing State",
          intro: "Track what happens as matter changes state and connect the observations to particle motion and energy. Extended learners deepen the same story with kinetic theory and heating curves.",
          keyIdeas: ["Changes of state are physical changes.", "Heating and cooling alter particle energy and arrangement."],
          objectives: [objective(3, 3, "Core - Interconversion of States of Matter"), objective(5, 5, "Supp - Kinetic Particle Theory and Heating Curves", "extended")],
          primaryVideoNames: ["Can matter change its state?-III"],
        },
        {
          key: "gas-volume",
          title: "Temperature, Pressure & Gas Volume",
          intro: "Use the particle model to explain why gases respond strongly to changes in temperature and pressure, then connect the qualitative picture to the relevant gas-law relationships.",
          keyIdeas: ["Gas pressure comes from particle collisions with container walls.", "Temperature, pressure and volume are linked for a fixed amount of gas."],
          objectives: [objective(4, 4, "Core-Temperature,  Pressure and Gas Volume"), objective(6, 6, "Supp - Kinetic Particle Theory: Gas Volume", "extended")],
          primaryVideoNames: ["The Gas Laws 2"],
        },
      ],
    },
    {
      key: "diffusion",
      title: "Diffusion",
      topicRef: { topicId: 2, sourceTopicId: 533, name: "Diffusion" },
      sections: [
        {
          key: "diffusion",
          title: "Diffusion",
          intro: "Use particle motion to explain why substances spread without stirring. Extended learners then connect relative molecular mass to differences in diffusion rate.",
          keyIdeas: ["Diffusion results from random particle motion.", "Lighter particles generally diffuse faster than heavier particles under comparable conditions."],
          objectives: [objective(7, 7, "Core - Diffusion and Kinetic Particle Theory"), objective(8, 8, "Suppl - Molecular Mass and Rate of Diffusion", "extended")],
          primaryVideoNames: ["Characteristics of particles of matter", "States of matter-I"],
        },
      ],
    },
  ],
};
